export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col bg-background-100 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'radial-gradient(circle at 30% 50%, oklch(0.5 0.01 80) 0%, transparent 50%), radial-gradient(circle at 70% 30%, oklch(0.45 0.01 75) 0%, transparent 50%)',
        }}
      />

      <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-transparent to-background-100/60" />

      <div className="relative flex flex-col items-center justify-center flex-1 px-4 md:px-8 pt-[72px]">
        <div className="w-full max-w-4xl mx-auto text-center">
          <div className="mb-16 md:mb-20">
            <h2 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold leading-[1.08] tracking-tight text-foreground-950">
              Crafting Digital
              <br />
              Excellence for the
              <br />
              iOS Platform
            </h2>
          </div>

          <div className="h-20 md:h-28" />
        </div>

        <div className="relative w-full max-w-5xl mx-auto h-[280px] md:h-[380px] lg:h-[440px]">
          <div
            className="absolute top-8 left-[8%] w-[28%] h-[85%] rounded-2xl bg-background-200 z-10"
            style={{
              transform: 'perspective(800px) rotateY(3deg) translateZ(-20px)',
              backgroundImage:
                'linear-gradient(135deg, oklch(0.90 0.003 84) 0%, oklch(0.84 0.004 82) 40%, oklch(0.88 0.003 83) 100%)',
            }}
          />

          <div
            className="absolute top-0 left-1/2 -translate-x-1/2 w-[30%] h-full rounded-2xl bg-background-50 z-20"
            style={{
              backgroundImage:
                'linear-gradient(160deg, oklch(0.94 0.002 85) 0%, oklch(0.88 0.003 83) 50%, oklch(0.90 0.002 84) 100%)',
            }}
          />

          <div
            className="absolute top-12 right-[6%] w-[28%] h-[82%] rounded-2xl bg-background-200 z-10"
            style={{
              transform: 'perspective(800px) rotateY(-3deg) translateZ(-20px)',
              backgroundImage:
                'linear-gradient(225deg, oklch(0.89 0.003 85) 0%, oklch(0.83 0.004 81) 40%, oklch(0.87 0.003 84) 100%)',
            }}
          />

          <div className="absolute bottom-0 left-[5%] w-[90%] h-[1px] bg-gradient-to-r from-transparent via-foreground-200/40 to-transparent" />
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
        <span className="text-xs tracking-[0.2em] uppercase text-foreground-500 font-medium">Scroll</span>
        <div className="w-[1px] h-8 bg-gradient-to-b from-foreground-400 to-transparent" />
      </div>
    </section>
  );
}